import { $fetch } from '@/boot/fetch'
import { replacePathTokens } from '@/utils/routes.util'

const ENDPOINT = '/retailers/{{retailerId}}/shippingPartners'

export default {
  async addSingle(retailerId, body) {
    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId }), {
      method: 'POST',
      body,
    })
  },

  async updateSingle(retailerId, partnerId, body) {
    return $fetch.peg(`${replacePathTokens(ENDPOINT, { retailerId })}/${partnerId}`, {
      method: 'PUT',
      body,
    })
  },
}
